import React, { FC, useEffect, useState, useRef } from "react";
import { Image, Button } from "antd-mobile";
import { useNavigate } from "react-router-dom";
import webButton from '../../assets/images/index-btn.png';
import webIndex from '../../assets/images/index.png';

import Container from '../../components/Container';

const node_env = process.env.NODE_ENV || "development";

const Index = () => {
  const navigator = useNavigate();
  let agent = useRef<any>("");
  useEffect(() => {
    let pathname = window.location.href;
    agent.current = pathname.split("agent=")[1];
  }, []);


  // 声明 config 类型
type AppConfig = {
  REGISTER_URL: string;
};

  // 点击跳转注册
  // const gotoRegister = () => {
    // navigator("/Register", {
    //   state: {
    //     agent: agent.current,
    //   },
    // });
  // };





  // const gotoRegister = () => {
  //   const currentOrigin = window.location.origin.toLowerCase();
  
  //   // 定义包含关键词和对应跳转链接的列表
  //   const domainMap: Record<string, string> = {
  //     "dzt9.cc": "https://h5.ngp6.xyz/?agent=5573665",
  //     "dzy9.cc": "https://h5.ngp6.xyz/?agent=6098722",
  //     "dze8.cc": "https://h5.ngp6.xyz/?agent=6098725",
  //   };
  
  //     console.log("_________")
  //   // 遍历 domainMap，查找当前域名中包含哪个关键字
  //   for (const key in domainMap) {
  //     if (currentOrigin.includes(key)) {
  //       window.location.href = domainMap[key];
  //       return;
  //     }
  //   }
  
  //   // 如果都没有匹配
  //   console.error(`未匹配到跳转地址：${window.location.origin}`);
  // };



  const gotoRegister = () => {
    const currentOrigin = window.location.origin.toLowerCase();

    const domainMap: Record<string, string> = {
      "dzt9.cc": "https://h5.ngp6.xyz/?agent=5573665",
      "dzy9.cc": "https://h5.ngp6.xyz/?agent=6098722",
      "dze8.cc": "https://h5.ngp6.xyz/?agent=6098725",
      "pkf7.cc": "https://h5.ngp6.xyz/?agent=6098722",
      "dzy1.cc": "https://h5.ngp6.xyz/?agent=6199247",
      "pkj8.cc": "https://h5.ngp6.xyz/?agent=6199247"
    };

    for (const key in domainMap) {
      if (currentOrigin.includes(key)) {
        window.location.href = domainMap[key];
        return;
      }
    }

    // 未匹配到任何 key，使用 navigator 跳转
    navigator("/Register", {
      state: {
        agent: agent.current,
      },
    });
  };



  


  return (
    <Container style={{ background: '#000', position: 'relative' }}>
  {/* 背景图 */}
  <Image
    src={webIndex}
    style={{ width: '100%', display: 'block' }}
  />

  {/* 按钮覆盖在图上，居中靠底 */}
  <Button
    onClick={gotoRegister}
    className="border-0 rounded-2xl"
    style={{
      position: 'absolute',         // 关键：相对于父容器绝对定位
      bottom: '60px',               // 离底部 40px
      left: '50%',                  // 水平中点
      transform: 'translateX(-50%)', // 向左移按钮自身一半，实现真正居中
      backgroundImage: `url(${webButton})`,
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundColor: 'transparent',
      width: 'auto',
      height: 'auto',
      padding: 0,
      display: 'inline-block',
    }}
  >
    <img src={webButton} alt="button" style={{ display: 'block' }} />
  </Button>
</Container>

  );
};

export default Index;
